import * as React from "react";
import {getTickets} from '../../api/tickets';
import {useCurrentCategory} from '../../utils';

import Page from '../../components/Page';
import ExamsList from "../../components/ExamsList";
import CustomBox from '../../components/CustomBox';

import {Grid, Typography, Box, CircularProgress} from "@mui/material";

const Tickets = () => {
	const [tickets, setTickets] = React.useState([]);
	const currentCategory = useCurrentCategory();

	React.useEffect(() => {
		getTickets(
			currentCategory.id,
			(res) => {
				setTickets(res.rows)
			}
		)
	}, []);

	return (
		<Page title="Билеты" backpath="/" resetExam>
			<CustomBox style={{ margin: '20px 0 40px 0'}}>
				<Grid container>
					<Grid item xs={12}>
						<Typography
							variant="h4"
							style={{fontWeight: 'bold'}}
							sx={{ fontSize: {xs: '20px', sm: '20px', md: '28px', lg: '34px'}}}
						>
							Билеты
						</Typography>
						<Typography
							variant="subtitle1"
							sx={{
								fontSize: {xs: '12px', sm: '12px', md: '14px', lg: '16px'},
								margin: {xs: '0 0 20px 0', sm: '0 0 20px 0', md: '0 0 20px 0', lg: '0 0 20px 0'}
						}}
						>
							Для начала прохождения теста, выберите билет.
						</Typography>
					</Grid>
				</Grid>
				{tickets?.length
					? (<ExamsList items={tickets} path='tickets'/>)
					: (
						<Box sx={{ display: 'flex', justifyContent: 'center' }}>
							<CircularProgress />
						</Box>
					)
				}

			</CustomBox>
		</Page>
	)
}

export default Tickets;